var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactsFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.508789 21C0.508789 18.8783 1.35164 16.8434 2.85193 15.3431C4.35223 13.8429 6.38706 13 8.50879 13C10.6305 13 12.6654 13.8429 14.1656 15.3431C15.6659 16.8434 16.5088 18.8783 16.5088 21H0.508789ZM8.50879 12C5.19379 12 2.50879 9.315 2.50879 6C2.50879 2.685 5.19379 0 8.50879 0C11.8238 0 14.5088 2.685 14.5088 6C14.5088 9.315 11.8238 12 8.50879 12ZM15.8718 14.233C17.4014 14.6261 18.7681 15.4918 19.7771 16.7068C20.7862 17.9218 21.3862 19.4242 21.4918 21H18.5088C18.5088 18.39 17.5088 16.014 15.8718 14.233ZM13.8488 11.957C14.6868 11.2075 15.3569 10.2893 15.8153 9.26275C16.2738 8.23616 16.5101 7.12429 16.5088 6C16.5109 4.63347 16.1614 3.28937 15.4938 2.097C16.6264 2.32459 17.6453 2.93737 18.3772 3.8312C19.1092 4.72502 19.509 5.84473 19.5088 7C19.5091 7.71247 19.357 8.41676 19.0629 9.06567C18.7688 9.71459 18.3393 10.2931 17.8033 10.7625C17.2674 11.2319 16.6373 11.5814 15.9552 11.7874C15.2732 11.9934 14.555 12.0512 13.8488 11.957V11.957Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsFilled);
export default __webpack_public_path__ + "static/media/ContactsFilled.a4a0d9f0ba983fc69d8c96763857881d.svg";
export { ForwardRef as ReactComponent };